export const RELEASE_MODAL_NAME = 'release_modal';
